import * as React from "react";
import { ContentProps } from "components/flexComponents/Content/typings";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { QueryRoute } from "bernie-core";
import { Layer } from "bernie-view";
import { UitkCard, UitkCardContent, UitkCardTextSegment, UitkCardSectionSeparatorType } from "uitk-react-cards";
import { UitkTertiaryButton, UitkButtonSize } from "uitk-react-button";
import { EditorialModel } from "typings/microserviceModels/content-flex-module";
import { decorateEditorialHtml } from "components/flexComponents/Content/ContentUtilities";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading } from "uitk-react-text";

export const EditorialInfoView = ({ items, props }: { items: EditorialModel[]; props: ContentProps }) => {
  const moreInfoRef = React.createRef<HTMLButtonElement>();
  /* istanbul ignore next */
  const openDialog = () => {
    if (props.routeStore) {
      props.routeStore.updateSearch({ pwaDialog: "more-info" });
    }
  };

  /* istanbul ignore next */
  const closeDialog = () => {
    if (props.routeStore) {
      props.routeStore.goBack();
    }
    if (moreInfoRef && moreInfoRef.current && typeof moreInfoRef.current.focus === "function") {
      moreInfoRef.current.focus();
    }
  };

  const { formatText } = useLocalization();

  return (
    <div className="uitk-type-paragraph-300" data-fm-content={items[0].id}>
      {items[0].title && (
        <UitkHeading level={2} size={600}>
          {items[0].title}
        </UitkHeading>
      )}

      {items[0].text && (
        <div className="all-t-padding-two uitk-type-300 infoMessage" onClick={openDialog}>
          <span dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)} />
          <UitkIcon name="info_outline" size={UitkIconSize.SMALL} />
        </div>
      )}
      <QueryRoute query={{ pwaDialog: "more-info" }}>
        <Layer id="more-info-dialog">
          <InfoDialog
            infoText={items[1].text}
            closeDialog={closeDialog}
            buttonText={formatText("editorial.moreInfo.dismissButton.label")}
          />
        </Layer>
      </QueryRoute>
    </div>
  );
};

const InfoDialog = ({
  infoText,
  closeDialog,
  buttonText,
}: {
  infoText?: string;
  closeDialog: () => void;
  buttonText: string;
}) => {
  const { useRef, useEffect } = React;
  const dialogRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (dialogRef && dialogRef.current) {
      dialogRef.current.focus();
    }
  }, []);

  return (
    <UitkCard className="editorialInfoDialog">
      <UitkCardContent>
        <UitkCardTextSegment className="all-cell-1-1 uitk-type-300" separator={UitkCardSectionSeparatorType.BOTTOM}>
          {infoText && <div dangerouslySetInnerHTML={decorateEditorialHtml(infoText)} />}
        </UitkCardTextSegment>
        <UitkTertiaryButton
          onClick={closeDialog}
          size={UitkButtonSize.LARGE}
          text={buttonText}
          isFullWidth={true}
          domRef={dialogRef}
        />
      </UitkCardContent>
    </UitkCard>
  );
};
